function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo, useRef } from 'react';
import { useFilters, useFlexLayout, useRowSelect, useSortBy, useTable } from 'react-table';
import { DefaultColumnFilter } from '../Header/Filters/DefaultFilter';
import { TableHeader } from './Header';
import { TableRow } from './Row';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SimpleTable = _ref => {
  let {
    columns,
    data,
    TableRowComponent = TableRow,
    selectRowId,
    disableFilters = true,
    sortBy,
    initialState,
    RowFooterComponent,
    sticky,
    stickTopPx,
    autoResetSortBy = false
  } = _ref;
  const listHeaderRef = useRef(null);
  React.useEffect(() => {
    if (selectRowId) {
      toggleAllRowsSelected(false);
      const rowIndex = rows.findIndex(row => row.id === selectRowId);
      if (rowIndex > -1) {
        toggleRowSelected(selectRowId, true);
      }
    }
  }, [selectRowId]);
  React.useEffect(() => {
    if (sortBy) {
      setSortBy(sortBy);
    }
  }, [sortBy]);
  const defaultColumn = useMemo(() => ({
    minWidth: 30,
    width: 150,
    maxWidth: 400,
    Filter: DefaultColumnFilter
  }), []);
  const stringArrayFilter = (rows, id, filterValue) => {
    return rows.filter(row => {
      const rowValue = row.values[id];
      return rowValue !== undefined ? String(rowValue).toLowerCase().startsWith(String(filterValue).toLowerCase()) : true;
    });
  };
  const filterTypes = React.useMemo(() => ({
    stringArrayFilter
  }), []);
  const {
    headerGroups,
    rows,
    getTableProps,
    getTableBodyProps,
    prepareRow,
    toggleRowSelected,
    toggleAllRowsSelected,
    setSortBy
  } = useTable({
    initialState: initialState,
    columns,
    data: data,
    defaultColumn,
    autoResetSelectedRows: false,
    autoResetSortBy: autoResetSortBy,
    disableFilters: disableFilters,
    // used casting to keep existing behavior, but it needs to be confirmed which is incorrect - typings or runtime type
    filterTypes: filterTypes
  }, useFlexLayout, useFilters, useSortBy, useRowSelect);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, getTableProps()), {}, {
    children: [/*#__PURE__*/_jsx(TableHeader, {
      headerGroups: headerGroups,
      componentRef: listHeaderRef,
      columns: columns,
      sticky: sticky,
      stickTopPx: stickTopPx
    }, 'header'), /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, getTableBodyProps()), {}, {
      children: rows.map(row => {
        prepareRow(row);
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(TableRowComponent, {
            row: row
          }, row.id), RowFooterComponent && /*#__PURE__*/_jsx(RowFooterComponent, {
            row: row
          }, "".concat(row.id, "-footer"))]
        }, row.id);
      })
    }))]
  }));
};